import { render, staticRenderFns } from "./selecionarvendedor.vue?vue&type=template&id=6b27a99a&scoped=true&"
import script from "./selecionarvendedor.vue?vue&type=script&lang=js&"
export * from "./selecionarvendedor.vue?vue&type=script&lang=js&"
import style0 from "./selecionarvendedor.vue?vue&type=style&index=0&id=6b27a99a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b27a99a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCardActions,VCardText,VCardTitle,VIcon,VSelect,VSpacer})
